import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
    *,
    *::before, 
    *::after {
        padding: 0; 
        margin: 0;
    }

    html {
        box-sizing: inherit;
        font-size: 62.5%;
    }

    body {
        box-sizing: border-box;
        font-size: 1.6rem;
        font-family: sans-serif;
        background-color: #F4F4F4;
        color: #717171;
    }

    a {
        text-decoration: none;
        color: #29ABE2;
    }
`